import { type PreferredLane, getPreferredLaneKey } from '../domain/PreferredLane'
import {
  dismissSuggestedPreferredLane,
  type SuggestedPreferredLane,
} from '../domain/SuggestedPreferredLane'
import { type SuggestedPreferredLaneRepository } from '../infra/SuggestedPreferredLaneRepository'
import { getSuggestedPreferredLanesFactory } from './getSuggestedPreferredLanes'

export type DismissSuggestedPreferredLane = (
  preferredLane: PreferredLane
) => Promise<SuggestedPreferredLane[]>

export type DismissSuggestedPreferredLaneDependencies = {
  suggestedPreferredLaneRepository: SuggestedPreferredLaneRepository
}

export function dismissSuggestedPreferredLaneFactory({
  suggestedPreferredLaneRepository,
}: DismissSuggestedPreferredLaneDependencies) {
  const getSuggestedPreferredLanes = getSuggestedPreferredLanesFactory({
    suggestedPreferredLaneRepository,
  })
  return async function dismissSuggestedPreferredLaneUseCase(preferredLane: PreferredLane) {
    try {
      const key = getPreferredLaneKey(preferredLane)
      let suggestedPreferredLane = await suggestedPreferredLaneRepository.getById(key)

      if (suggestedPreferredLane != null) {
        suggestedPreferredLane = dismissSuggestedPreferredLane(suggestedPreferredLane)

        await suggestedPreferredLaneRepository.upsert(key, suggestedPreferredLane)
      }

      const suggestions = getSuggestedPreferredLanes()

      return suggestions
    } catch (error) {
      throw new Error('Failed to dismiss Suggested Preferred Lane', { cause: error as Error })
    }
  }
}
